module.exports = __webpack_public_path__ + "def5e3fc058ce84e6273e0f6a9b01786.png";